/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailShipping_item = {
    readonly hasShipmentQuotes: boolean | null;
    readonly hasPreQuotedShipping: boolean | null;
    readonly itemIsOnHold: boolean | null;
    readonly attributes: {
        readonly leadTime: ReadonlyArray<{
            readonly option: {
                readonly urlLabel: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_item" | "freeShippingHelpers_item">;
    readonly " $refType": "PdpSharedDetailShipping_item";
};
export type PdpSharedDetailShipping_item$data = PdpSharedDetailShipping_item;
export type PdpSharedDetailShipping_item$key = {
    readonly " $data"?: PdpSharedDetailShipping_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailShipping_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasShipmentQuotes",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasPreQuotedShipping",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "itemIsOnHold",
      "name": "isOnHold",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "attributes",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "leadTime",
          "storageKey": null,
          "args": null,
          "concreteType": "AttributeValue",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "option",
              "storageKey": null,
              "args": null,
              "concreteType": "AttributeOption",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "urlLabel",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_item",
      "args": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "freeShippingHelpers_item",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "vertical",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shipmentQuotes",
          "storageKey": null,
          "args": null,
          "concreteType": "ShipmentQuote",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isComplimentary",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "totalAmount",
              "storageKey": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "serviceMethod",
              "storageKey": null,
              "args": null,
              "concreteType": "ShipmentServiceMethod",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "region",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Region",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "regionName",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '36e973f6163d947a1f7cf23cdf910106';
export default node;
